import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-icon fill-block"
}
const _hoisted_2 = {
  key: 1,
  class: "options"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_PhotoIcon = _resolveComponent("PhotoIcon")!
  const _component_NcListItem = _resolveComponent("NcListItem")!
  const _component_LargePhotoIcon = _resolveComponent("LargePhotoIcon")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_LinkIcon = _resolveComponent("LinkIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup,
        size: "normal"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.n('memories', 'Share File', 'Share Files', _ctx.photos?.length ?? 0)), 1)
        ]),
        default: _withCtx(() => [
          (_ctx.loading > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_XLoadingIcon)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_ctx.canShareNative && _ctx.canShareLowRes)
                  ? (_openBlock(), _createBlock(_component_NcListItem, {
                      key: 0,
                      name: _ctx.t('memories', 'Reduced Size'),
                      bold: false,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.shareLowRes()), ["prevent"]))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_PhotoIcon, {
                          class: "avatar",
                          size: 24
                        })
                      ]),
                      subname: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share in lower quality (small file size)')), 1)
                      ]),
                      _: 1
                    }, 8, ["name"]))
                  : _createCommentVNode("", true),
                (_ctx.canShareNative && _ctx.canShareHighRes)
                  ? (_openBlock(), _createBlock(_component_NcListItem, {
                      key: 1,
                      name: _ctx.t('memories', 'High Resolution'),
                      bold: false,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.shareHighRes()), ["prevent"]))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_LargePhotoIcon, {
                          class: "avatar",
                          size: 24
                        })
                      ]),
                      subname: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share in high quality (large file size)')), 1)
                      ]),
                      _: 1
                    }, 8, ["name"]))
                  : _createCommentVNode("", true),
                (_ctx.canShareNative && _ctx.canDownload)
                  ? (_openBlock(), _createBlock(_component_NcListItem, {
                      key: 2,
                      name: _ctx.t('memories', 'Original File'),
                      bold: false,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.shareOriginal()), ["prevent"]))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_FileIcon, {
                          class: "avatar",
                          size: 24
                        })
                      ]),
                      subname: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.n('memories', 'Share the original file', 'Share the original files', _ctx.photos?.length ?? 0)), 1)
                      ]),
                      _: 1
                    }, 8, ["name"]))
                  : _createCommentVNode("", true),
                (_ctx.canShareLink)
                  ? (_openBlock(), _createBlock(_component_NcListItem, {
                      key: 3,
                      name: _ctx.t('memories', 'Public Link'),
                      bold: false,
                      onClick: _withModifiers(_ctx.shareLink, ["prevent"])
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_LinkIcon, {
                          class: "avatar",
                          size: 24
                        })
                      ]),
                      subname: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share an external Nextcloud link')), 1)
                      ]),
                      _: 1
                    }, 8, ["name", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}